"use client"
import { Button } from "rsuite"
import Carousel from 'react-multi-carousel';
import { config } from '../../data/config';
// import 'react-multi-carousel/lib/styles.css';

export default function ShowArticleContainer({ data }: any) {
    return (
        <div className={`grid grid-cols-12  gap-2`} dir="ltr">
            {
                data.map((item: any) => {
                    return (
                        <div className={`${ item.cols == 2 && 'lg:col-span-6 col-span-12' }
                         ${ item.cols == 3 && 'lg:col-span-4 col-span-12' }
                        ${ item.cols == 1 && 'lg:col-span-12 col-span-12 ' } `} >
                            {
                                item.toCompoennt.map((i: any) => {
                                    return (
                                        <div dir="rtl p-4">
                                            {i.mode == "image" && <ImagePreview data={i}></ImagePreview>}
                                            {i.mode == "heading" && <HeadingPreview data={i}></HeadingPreview>}
                                            {i.mode == "text" && <TextPreview data={i}></TextPreview>}
                                            {i.mode == "catalog" && <CatalogPreview data={i}></CatalogPreview>}
                                            {i.mode == "gallery" && <GalleryPreview data={i}></GalleryPreview>}
                                            {i.mode == "slider" && <SliderPreview data={i}></SliderPreview>}
                                            {i.mode == "movie" && <MoviePlayer data={i}></MoviePlayer>} 


                                        </div>
                                    )
                                })
                            }

                        </div>
                    )
                })
            }
        </div>
    )
}
const MoviePlayer=(data:any)=>{
    return(
        <div>
            {
                data.data.data!=null && <div className="h_iframe-aparat_embed_frame">
                    {/* <span style={display: block;padding-top: 57%}></span> */}
                    <iframe style={{width:'100%',height:'300px'}} src={`https://www.aparat.com/video/video/embed/videohash/${data.data.data.text}/vt/frame`}  allowFullScreen={true}  ></iframe>
                    </div>
            }
        </div>
    )
}
const CatalogPreview = (data: any) => {
    return (
        <div>

            {
            data.data.toimage!=null &&    data.data.toimage.map((item: any) => {
                    return (
                        <div className="text-center max-w-[200px] m-auto" dir="rtl" >
                            <a href={item.url}>
                                 <button>دانلود</button>

                            </a>
                        </div>
                    )
                })
            }

        </div>
    )
}

const SliderPreview = (data: any) => {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return (
        <div>
            <Carousel
                responsive={responsive}
            >
                {
                    data.data.toimage.map((item: any) => {
                        return (
                            <div className="text-center p-3">
                                <img width={'100%'} src={config.url+item.url}></img>

                            </div>
                        )
                    })
                }
            </Carousel>


        </div>
    )
}
const GalleryPreview = (data: any) => {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 6
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 6
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 5
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return (
        <div>
            <Carousel
                responsive={responsive}
            >
                {
                    data.data.toimage.map((item: any) => {
                        return (
                            <div className="text-center p-3">
                                <img src={config.fronturl+item.url}></img>

                            </div>
                        )
                    })
                }
            </Carousel>


        </div>
    )
}
const TextPreview = (data: any) => {
    return (
        <div dir="rtl" className="p-4">
            {
                data.data.data != null && <div  dangerouslySetInnerHTML={{ __html: data.data.data.html }}></div>

            }
        </div>
    )
}
const ImagePreview = (data: any) => {
    return (
        <div>
           {data.data.toimage!=null && data.data.toimage.length != 0 && <img  className={`rounded-2xl`} src={config.fronturl+data.data.toimage[0].url}  width={'100%'} />}
            {/* {
                 data.data.data!=null &&       <div contentEditable='true' dangerouslySetInnerHTML={{ __html:data.data.data.html }}></div>

            } */}

        </div>
    )
}
const HeadingPreview = (data: any) => {
    return (
        <div>{
            data.data.data != null && <div dir="rtl">
                {data.data.data.mode == "h1" && <h1 className="text-right font-bold text-[16px]">{data.data.data.text}</h1>}
                {data.data.data.mode == "h2" && <h2 className="text-right font-bold text-[14px]">{data.data.data.text}</h2>}
                {data.data.data.mode == "h3" && <h3 className="text-right font-bold text-[12px]">{data.data.data.text}</h3>}

                {data.data.data.mode == "h4" && <h4 className="text-right font-bold text-[10px]">{data.data.data.text}</h4>}
                {data.data.data.mode == "h5" && <h5 className="text-right  text-[10px]">{data.data.data.text}</h5>}
                {data.data.data.mode == "h6" && <h6 className="text-right  text-[10px]">{data.data.data.text}</h6>}


            </div>
        }
        </div>
    )
}